import { render, staticRenderFns } from "./ItemNewsModal.vue?vue&type=template&id=935324f4&scoped=true"
import script from "./ItemNewsModal.vue?vue&type=script&lang=js"
export * from "./ItemNewsModal.vue?vue&type=script&lang=js"
import style0 from "./ItemNewsModal.vue?vue&type=style&index=0&id=935324f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935324f4",
  null
  
)

export default component.exports